import { createContext } from "react"

export enum NotificationType {
  PROJECT_TEAM_INVITATIONS = "project_team_invitations",
  PORTAL_NEWS = "portal_news"
}

export interface NotificationContextType {
  [NotificationType.PROJECT_TEAM_INVITATIONS]: number
  [NotificationType.PORTAL_NEWS]: number
}

export const NotificationContext =
  createContext<NotificationContextType | null>(null)

export function isNotificationType(type: string): type is NotificationType {
  return Object.values(NotificationType).includes(type as NotificationType)
}
